module.exports = __webpack_public_path__ + "media/images/design/images/btn_report-fa009809eb984d0a07c5e71f7fda4fc3.png";